var $7ac7881cfca662a6$exports = {};
$7ac7881cfca662a6$exports = {
    "help": `Pomo\u{10D}`,
    "info": `Informacije`
};


export {$7ac7881cfca662a6$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
